import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Link, Logo, Social, Text } from 'view/atoms';
import * as S from './Footer.styles';

export const Footer = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <S.FooterStyled>
      <S.FooterTopWrap>
        <S.LogoWrap>
          <Logo isFooter />
        </S.LogoWrap>
        <S.TextWrap>
          <Text kind='small1' color='gray3'>
            {t('footer.mainText')}
          </Text>
        </S.TextWrap>
        <S.LinkWrap>
          <S.Title kind='h4' color='gray3'>
            {t('footer.siteTitle')}
          </S.Title>
          <Link
            href='https://www.andersenlab.com'
            color={theme.colors.gray3}
            withIcon
          >
            www.andersenlab.com
          </Link>
        </S.LinkWrap>
        <S.Title kind='h4' color='gray3'>
          {t('footer.socialTitle')}
        </S.Title>
        <Social />
      </S.FooterTopWrap>
      <S.FooterBottomWrap>
        <S.PrivacyPolicyWrap>
          <Link
            color={theme.colors.gray3}
            href='https://andersenlab.com/privacy-policy'
          >
            Privacy Policy
          </Link>
        </S.PrivacyPolicyWrap>
        {/* TODO: Research where take text for copyright */}
        <Text kind='small1' color='gray3'>
          ©{new Date().getFullYear()} Andersen Software Inc. All Rights
          Reserved.
        </Text>
      </S.FooterBottomWrap>
    </S.FooterStyled>
  );
};
